const stats = [
  { value: '18+', label: 'лет опыта' },
  { value: '100+', label: 'корпоративных проектов' },
  { value: '450+', label: 'обучающих программ' },
  { value: '4500+', label: 'обученных сотрудников' },
];

export default function StatisticsSection() {
  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, i) => (
            <div key={i} className="text-center p-6 bg-gray-50 rounded-2xl border border-gray-100">
              <div className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-teal-600 mb-2 whitespace-nowrap">{stat.value}</div>
              <div className="text-sm text-gray-600 leading-snug">{stat.label}</div>
            </div>
          ))}
        </div>
        <p className="text-center text-gray-500 text-sm mt-6">
          Работа с компаниями Беларуси, России, Казахстана и Израиля
        </p>
      </div>
    </section>
  );
}